// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolNodeId } from './BrewcontrolNode';
import { z } from 'zod';
export const brewcontrolRoutineRunId = (z.string());
export const brewcontrolRoutineRun = z.object({
    id: brewcontrolRoutineRunId,
    node_id: brewcontrolNodeId,
    name: z.string(),
    params: z.unknown(),
    origin: z.string(),
    state: z.string(),
    result: z.unknown().nullable(),
    error: z.string().nullable(),
    started_at: z.date(),
    finished_at: z.date().nullable(),
});
export const brewcontrolRoutineRunInitializer = z.object({
    id: brewcontrolRoutineRunId,
    node_id: brewcontrolNodeId,
    name: z.string(),
    params: z.unknown().optional(),
    origin: z.string().optional(),
    state: z.string().optional(),
    result: z.unknown().optional().nullable(),
    error: z.string().optional().nullable(),
    started_at: z.date().optional(),
    finished_at: z.date().optional().nullable(),
});
export const brewcontrolRoutineRunMutator = z.object({
    id: brewcontrolRoutineRunId.optional(),
    node_id: brewcontrolNodeId.optional(),
    name: z.string().optional(),
    params: z.unknown().optional(),
    origin: z.string().optional(),
    state: z.string().optional(),
    result: z.unknown().optional().nullable(),
    error: z.string().optional().nullable(),
    started_at: z.date().optional(),
    finished_at: z.date().optional().nullable(),
});
//# sourceMappingURL=BrewcontrolRoutineRun.js.map